import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { PacApiModule } from 'pac-api';

import {
  A5mmDescriptionComponent,
} from '../association-level/additional-options/a5mm-option/a5mm-description/a5mm-description.component';
import {
  ExamcoachDescriptionComponent,
} from '../association-level/additional-options/examcoach-option/examcoach-description/examcoach-description.component';
import { AssociationLevelComponent } from '../association-level/association-level.component';
import { AlertModalComponent } from './alert-modal/alert-modal.component';
import { ColorboxFetchComponent } from './colorbox-fetch/colorbox-fetch.component';
import { ColorboxInlineComponent } from './colorbox-inline/colorbox-inline.component';
import { ColorboxDirective } from './directives/colorbox.directive';
import { GatedLinkDirective } from './directives/gated-link.directive';
import { GenericErrorHandlerService } from './generic-error-handler.service';
import { HotStoneComponent } from './hot-stone/hot-stone.component';
import { LicenseComponent } from './license/license.component';
import { NumberOrdinalPipe } from './number-ordinal.pipe';
import { PopupService } from './popup.service';
import { PriceSummaryComponent } from './price-summary/price-summary.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { SchoolInstructorReferralComponent } from './school/school-instructor-referral/school-instructor-referral.component';
import { SchoolComponent } from './school/school.component';
import { SharedErrorLoginComponent } from './shared-templates/shared-error-login.component';
import { SignupHeaderComponent } from './signup-header/signup-header.component';
import {
  TrainingValidationErrorsComponent,
} from './training/training-validation-errors/training-validation-errors.component';
import { TrainingComponent } from './training/training.component';

@NgModule({
  declarations: [
    A5mmDescriptionComponent,
    AlertModalComponent,
    AssociationLevelComponent,
    ColorboxDirective,
    ColorboxFetchComponent,
    ColorboxInlineComponent,
    ExamcoachDescriptionComponent,
    GatedLinkDirective,
    HotStoneComponent,
    LicenseComponent,
    NumberOrdinalPipe,
    PriceSummaryComponent,
    ProgressBarComponent,
    SchoolComponent,
    SchoolInstructorReferralComponent,
    SharedErrorLoginComponent,
    SignupHeaderComponent,
    TrainingComponent,
    TrainingValidationErrorsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule,
    BsDatepickerModule,
    ModalModule,
    TypeaheadModule,
    TooltipModule,
    PacApiModule,
    RouterModule.forChild([]),
    FontAwesomeModule,
  ],
  exports: [
    A5mmDescriptionComponent,
    AlertModalComponent,
    AssociationLevelComponent,
    ColorboxDirective,
    ExamcoachDescriptionComponent,
    GatedLinkDirective,
    HotStoneComponent,
    LicenseComponent,
    NumberOrdinalPipe,
    PriceSummaryComponent,
    ProgressBarComponent,
    SchoolComponent,
    SchoolInstructorReferralComponent,
    SharedErrorLoginComponent,
    SignupHeaderComponent,
    TrainingComponent,
    TrainingValidationErrorsComponent,
  ],
  providers: [
    PopupService,
    GenericErrorHandlerService,
  ],
})
export class SharedModule {

}
